import React, { useState } from 'react';
import {
    AppBar,
    Toolbar,
    IconButton,
    Button,
    Box,
    Drawer,
    List,
    ListItem,
    ListItemText,
    useMediaQuery,
    Slide,
    useScrollTrigger
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@mui/material/styles';
import { NavLink, Link } from 'react-router-dom';
import logo from "../images/logo.png";

const navItems = [
    { url: 'Home', label: 'Home' },
    { url: 'Packages', label: 'Packages' },
    { url: 'InternationalTrips', label: 'International Trips' },
    { url: 'DomesticTrips', label: 'Domestic Trips' },
    { url: 'Contact', label: 'Contact' },
    { url: 'AboutUs', label: 'About Us' }
];

// Optional: Smooth hide on scroll
function HideOnScroll({ children }) {
    const trigger = useScrollTrigger();
    return (
        <Slide appear={false} direction="down" in={!trigger}>
            {children}
        </Slide>
    );
}

const Navbar = () => {
    const [drawerOpen, setDrawerOpen] = useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const toggleDrawer = (open) => () => {
        setDrawerOpen(open);
    };

    return (
        <>
            <HideOnScroll>
                <AppBar position="fixed" sx={{ backgroundColor: '#ffffff', boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}>
                    <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', px: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            {isMobile && (
                                <IconButton onClick={toggleDrawer(true)} sx={{ color: '#0e8279', mr: 1 }}>
                                    <MenuIcon />
                                </IconButton>
                            )}
                            <Link to="/" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
                                <Box
                                    component="img"
                                    src={logo}
                                    alt="Logo"
                                    sx={{ height: 40 }}
                                />
                            </Link>
                        </Box>

                        {!isMobile && (
                            <Box sx={{ display: 'flex', gap: 2 }}>
                                {navItems.map((item) => (
                                    <Button
                                        key={item.url}
                                        component={NavLink}
                                        to={item.label === 'Home' ? '/' : `/${item.url.toLowerCase()}`}
                                        sx={{
                                            color: '#333',
                                            fontWeight: 500,
                                            fontSize: '1rem',
                                            textTransform: 'capitalize',
                                            position: 'relative',
                                            '&::after': {
                                                content: '""',
                                                position: 'absolute',
                                                left: 0,
                                                bottom: 0,
                                                height: '2px',
                                                width: 0,
                                                backgroundColor: '#0e8279',
                                                transition: 'width 0.3s',
                                            },
                                            '&:hover::after': {
                                                width: '100%',
                                            },
                                            '&.active': {
                                                color: '#0e8279',
                                                fontWeight: 'bold',
                                            }
                                        }}
                                    >
                                        {item.label}
                                    </Button>
                                ))}
                            </Box>
                        )}
                    </Toolbar>
                </AppBar>
            </HideOnScroll>

            <Toolbar /> {/* Spacer below fixed AppBar */}

            {/* Mobile Drawer */}
            <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
                <Box sx={{ width: 260 }}>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            px: 2,
                            py: 1,
                            borderBottom: '1px solid #eee',
                        }}
                    >
                        <Box component="img" src={logo} alt="Logo" sx={{ height: 36 }} />
                        <IconButton onClick={toggleDrawer(false)}>
                            <CloseIcon />
                        </IconButton>
                    </Box>

                    <List>
                        {navItems.map((text) => (
                            <ListItem
                                button
                                key={text.url}
                                component={NavLink}
                                to={text.label === 'Home' ? '/' : `/${text.url.toLowerCase()}`}
                                onClick={toggleDrawer(false)}
                                sx={{
                                    px: 3,
                                    py: 1.5,
                                    color: '#444',
                                    '&.active': {
                                        backgroundColor: '#f2fafa',
                                        color: '#0e8279',
                                        fontWeight: 'bold',
                                    },
                                    '&:hover': {
                                        backgroundColor: '#f9f9f9',
                                    }
                                }}
                            >
                                <ListItemText primary={text.label} />
                            </ListItem>
                        ))}
                    </List>
                </Box>
            </Drawer>
        </>
    );
};

export default Navbar;
